export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-background py-8">
      <div className="max-w-7xl mx-auto px-4 text-center text-muted-foreground text-sm">
        &copy; {new Date().getFullYear()} Fairmeadow Capital. All rights reserved.
      </div>
    </footer>
  )
}
